import {
	OPEN_MODAL_EDIT_USER_ACCESS_CODE,
	CLOSE_MODAL_EDIT_USER_ACCESS_CODE,
} from "Store/constants";

export const initialState = {
	isOpen : false,
	data   : {},
};

const ModalCreateUserAccessCodeContainer = (state = initialState, action) => {
	switch (action.type) {
		case OPEN_MODAL_EDIT_USER_ACCESS_CODE:
			return {
				...initialState,
				isOpen : true,
				...action.payload,
			};
		case CLOSE_MODAL_EDIT_USER_ACCESS_CODE:
			return {
				...initialState,
			};
		default:
			return state;
	}
};

export default ModalCreateUserAccessCodeContainer;
